import { createSlice } from '@reduxjs/toolkit';
import { MoveStagedAliquotState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { moveStagedAliquotThunk } from './thunks';

// Initial State
const initialState: MoveStagedAliquotState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const moveStagedAliquotSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    moveStagedAliquotReset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(moveStagedAliquotThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(moveStagedAliquotThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
      state.values = null;
    });
    builder.addCase(moveStagedAliquotThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { moveStagedAliquotReset } = moveStagedAliquotSlice.actions;
export * from './thunks';
export default moveStagedAliquotSlice.reducer;
